import { Component, OnInit, Input } from '@angular/core';
import { SatisfactionRateAnswerCategory } from './../../../../../models/reporting/satisfaction-rate-answer-category.enum';
import { SatisfactionRateValue } from './../../../../../models/reporting/satisfaction-rate-value.model';
import { SatisfactionRateQuestion } from './../../../../../models/reporting/satisfaction-rate-question.model';

@Component({
  selector: 'app-satisfaction-rate',
  templateUrl: './satisfaction-rate.component.html',
  styles: []
})
export class SatisfactionRateComponent implements OnInit {
  @Input() satisfaction: SatisfactionRateQuestion;
  negative: number;
  neutral: number;
  positive: number;
  minSatisfaction: SatisfactionRateValue;
  maxSatisfaction: SatisfactionRateValue;
  averageSatisfaction: SatisfactionRateValue;
  satisfactionRateAnswerCategory: any = SatisfactionRateAnswerCategory;

  private svgPath = '/assets/images/svg/person_gray_AMMOUNT.svg';

  ngOnInit() {
    this.minSatisfaction = this.getMin(this.satisfaction);
    this.maxSatisfaction = this.getMax(this.satisfaction);
    this.averageSatisfaction = this.satisfaction.values.find(x => 
      x.satisfactionRateAnswerCategory !== this.minSatisfaction.satisfactionRateAnswerCategory &&
      x.satisfactionRateAnswerCategory !== this.maxSatisfaction.satisfactionRateAnswerCategory);
    this.calculateDisplayPersonAmmount();
     }

  handleSVG(svg: SVGElement, parent: Element | null): SVGElement {
    svg.setAttribute('height', '65');
    return svg;
  }

  getRateSVG(personsAmmount): string {
    return this.svgPath.replace('AMMOUNT', personsAmmount);
  }

  getValue(satisfactionRateAnswerCategory: SatisfactionRateAnswerCategory) {
    return this.satisfaction.values.find(x => x.satisfactionRateAnswerCategory === satisfactionRateAnswerCategory).value;
  }

  getPositiveValue() {
    return this.satisfaction.values.find(x => x.satisfactionRateAnswerCategory === SatisfactionRateAnswerCategory.Positive).value;
  }

  private setDefaultPersonAmmount() {
    const minAmmount = 1;
    const avarageAmmount = 2;
    const maxAmmount = 3;
    if (this.minSatisfaction.value === this.maxSatisfaction.value) {
      this.negative = this.neutral = this.positive = avarageAmmount;
      return;
    } else if (this.minSatisfaction.value === this.averageSatisfaction.value) {
      this.negative = this.neutral = minAmmount;
      this.positive = 4;
      return;
     }  else if (this.maxSatisfaction.value === this.averageSatisfaction.value) {
       this.positive = maxAmmount; this.neutral = avarageAmmount;
       this.negative = minAmmount;
       return;
     }
    this.calculateDisplayRate(this.minSatisfaction.satisfactionRateAnswerCategory, minAmmount);
    this.calculateDisplayRate(this.maxSatisfaction.satisfactionRateAnswerCategory, maxAmmount);
    this.calculateDisplayRate(this.averageSatisfaction.satisfactionRateAnswerCategory, avarageAmmount);    
  }

  private setPersonAmountTwoAnswers(satisfactionWithValues: Array<SatisfactionRateValue>) {
    satisfactionWithValues.sort((a, b) => {
      if (a.value > b.value) {
        this.calculateDisplayRate(a.satisfactionRateAnswerCategory, 4);
        this.calculateDisplayRate(b.satisfactionRateAnswerCategory, 2);
        return 1;
      } else if (a.value < b.value) {
        this.calculateDisplayRate(a.satisfactionRateAnswerCategory, 2);
        this.calculateDisplayRate(b.satisfactionRateAnswerCategory, 4);
        return -1;
      } else {
        this.calculateDisplayRate(a.satisfactionRateAnswerCategory, 3);
        this.calculateDisplayRate(b.satisfactionRateAnswerCategory, 3);
        return 0;
      }
    });
  }

  private setPersonAmountOneAnswer(satisfactionWithValue: SatisfactionRateValue) {
    this.calculateDisplayRate(satisfactionWithValue.satisfactionRateAnswerCategory, 6);
  }

  private calculateDisplayPersonAmmount() {
      const satisfactionWithValues = this.satisfaction.values.filter(x => x.value !== 0);
        switch (satisfactionWithValues.length) {
        case 3:
          this.setDefaultPersonAmmount();
          break;
          case 2:
          this.setPersonAmountTwoAnswers(satisfactionWithValues);
          break;
          case 1:
          this.setPersonAmountOneAnswer([...satisfactionWithValues].shift());
          break;
        default:
          break;
      }
  }

  private getMin(satisfactions: SatisfactionRateQuestion): 
  SatisfactionRateValue {
    const minValue = Math.min(...satisfactions.values.map(x => x.value));
    return satisfactions.values.find(x => x.value === minValue);
  }

  private getMax(satisfactions: SatisfactionRateQuestion): 
  SatisfactionRateValue {
    const maxValue = Math.max(...satisfactions.values.map(x => x.value));
    return satisfactions.values.find(x => x.value === maxValue);
  }

  private calculateDisplayRate(satisfactionType: number, ammount: number) {
    switch (satisfactionType) {
      case 1:
        this.negative = ammount;
        break;
      case 2:
        this.neutral = ammount;
        break;
      case 3:
        this.positive = ammount;
        break;
    }
  }

}
